import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { IntroProductNav } from '@fff-web/fff-global-nav';
import {
  initialize as initializeAnalytics,
  trackPageLoad,
} from '@fff-web/fff-analytics';
import {
  PaymentProvider,
  PricesProvider,
  HCaptchaProvider,
} from '@fff-web/fff-payments';
import LoadingSpinner from '@fff-web/fff-ui-shared/LoadingSpinner';
import { useDecision } from '@optimizely/react-sdk';

import PublicShopProvider from '../GTBCustomize/ContextProviders/PublicShopContext';
import CheckoutV2 from '../../components/CheckoutV2';
import SharedProvider, {
  useSharedContext,
} from '../GTBCustomize/ContextProviders/SharedContext';
import EXPERIENCE_FLOW from '../../utils/constants/experienceFlow';
import { getAccountData } from '../../utils/Data/aceConnector';
import env from '../../utils/env';
import styles from '../PublicShop/PublicShop.module.css';

const GTB_PATH = 'get-the-box';
const CHECKOUT_TESTING_FF = 'checkout-v2';

const CheckoutTest = () => {
  const [checkoutFF] = useDecision(CHECKOUT_TESTING_FF);
  const isFFEnabled = checkoutFF.enabled && checkoutFF.variationKey === 'on';
  const { initialLoading } = useSharedContext();
  const { enableApplePaySocialEcomm, checkoutIntroBundle } = useFlags();
  const [anonymousUser, setAnonymousUser] = useState(false);

  // call the accounts endpoint to check logged in users
  useEffect(() => {
    getAccountData()
      .then(({ status }) => {
        if (status === 401) {
          setAnonymousUser(true);
        } else {
          window.location.replace(`${env.envURL}/`);
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  }, []);

  // redirect to GTB if the checkout-intro-bundle FF is OFF
  useEffect(() => {
    if (!checkoutIntroBundle) {
      window.location.replace(`${env.envURL}/${GTB_PATH}`);
    }
  }, [checkoutIntroBundle]);

  useEffect(() => {
    if (anonymousUser) {
      initializeAnalytics().then(() => {
        trackPageLoad();
      });
    }
  }, [anonymousUser]);

  if (!isFFEnabled) return null;

  if (initialLoading) return <LoadingSpinner />;

  if (!anonymousUser) return null;

  return (
    <>
      <IntroProductNav />
      <div className={styles.gradient} />
      <CheckoutV2 title="Checkout" flags={{ enableApplePaySocialEcomm }} />
    </>
  );
};

const WrappedCheckout = () => (
  <HCaptchaProvider>
    <PaymentProvider>
      <PricesProvider>
        <SharedProvider experienceFlow={EXPERIENCE_FLOW.publicShop}>
          <PublicShopProvider>
            <CheckoutTest />
          </PublicShopProvider>
        </SharedProvider>
      </PricesProvider>
    </PaymentProvider>
  </HCaptchaProvider>
);

export default WrappedCheckout;
